export const SizeMB = 1024 * 1024;

export const supportPreview = [
  'doc',
  'dot',
  'wps',
  'wpt',
  'docx',
  'dotx',
  'docm',
  'dotm',
  'rtf',
  'xls',
  'xlt',
  'et',
  'xlsx',
  'xltx',
  'csv',
  'xlsm',
  'xltm',
  'ppt',
  'pptx',
  'pptm',
  'ppsx',
  'ppsm',
  'pps',
  'potx',
  'potm',
  'dpt',
  'dps',
  'pdf',
  'jpg',
  'png',
  'jpeg',
  'gif',
  'bmp',
  'tif',
];

export const supportEdit = [
  'doc',
  'dot',
  'wps',
  'wpt',
  'docx',
  'dotx',
  'docm',
  'dotm',
  'xls',
  'xlt',
  'et',
  'xlsx',
  'xltx',
  'xlsm',
  'xltm',
  'ppt',
  'pptx',
  'pptm',
  'ppsx',
  'ppsm',
  'pps',
  'potx',
  'potm',
  'dpt',
  'dps',
  'pdf',
  'rtf',
];
